import { useState, useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const THINKING_LABELS = [/*#__PURE__*/_jsx(FormattedMessage, {
  message: "academy-ai-assistant.chat.thinkingLabels.thinking"
}, "thinking"), /*#__PURE__*/_jsx(FormattedMessage, {
  message: "academy-ai-assistant.chat.thinkingLabels.workingOnIt"
}, "workingOnIt"), /*#__PURE__*/_jsx(FormattedMessage, {
  message: "academy-ai-assistant.chat.thinkingLabels.lookingIntoThat"
}, "lookingIntoThat"), /*#__PURE__*/_jsx(FormattedMessage, {
  message: "academy-ai-assistant.chat.thinkingLabels.analyzingQuestion"
}, "analyzingQuestion"), /*#__PURE__*/_jsx(FormattedMessage, {
  message: "academy-ai-assistant.chat.thinkingLabels.puttingItTogether"
}, "puttingItTogether")];
const INTERVAL_MS = 2500;
export const useRotatingThinkingLabel = active => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (!active) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIndex(0);
      return;
    }
    const timer = setInterval(() => {
      setIndex(prev => (prev + 1) % THINKING_LABELS.length);
    }, INTERVAL_MS);
    return () => clearInterval(timer);
  }, [active]);
  return THINKING_LABELS[index];
};